export const algorithmOptions = [
  {
    value: 'des',
    text: 'DES'
  },
  {
    value: 'aes',
    text: 'AES'
  },
  {
    value: 'blowfish',
    text: 'Blowfish'
  },
  {
    value: '3des',
    text: '3DES'
  },
  {
    value: 'idea',
    text: 'IDEA'
  },
];

export const operationOptions = [
  {
    value: 'cypher',
    text: 'Cifrar'
  },
  {
    value: 'decipher',
    text: 'Decifrar'
  }
];
